interface StoreBadgeProps {
  href: string;
  src: string;
  alt: string;
  testId: string;
}

export function StoreBadge({ href, src, alt, testId }: StoreBadgeProps) {
  return (
    <a href={href} data-testid={testId} className='inline-block'>
      <img src={src} alt={alt} className='h-12' />
    </a>
  );
}
